import { IGetRatingListResponseData } from '../../../services/getRealtorRatingList';
import { ERealtorRatingTableColumns, RealtorRatingTableSortableColumnNames } from '../../../constants';
import { ESortOrder } from '../../../types/sortOrder';

interface ISortRealtorRatingItems {
  items: IGetRatingListResponseData[];
  sortOrdering: ERealtorRatingTableColumns;
  sortOrderingType: ESortOrder;
}
/**
 * Сортирует список риелторов по атрибутам
 */
export const sortRealtorRatingItems = ({ items, sortOrdering, sortOrderingType }: ISortRealtorRatingItems) => {
  return items.sort((a, b) => {
    const aSortedValue = a.attributes[RealtorRatingTableSortableColumnNames[sortOrdering]] as number;
    const bSortedValue = b.attributes[RealtorRatingTableSortableColumnNames[sortOrdering]] as number;

    return (aSortedValue - bSortedValue) * (sortOrderingType === ESortOrder.Asc ? 1 : -1);
  });
};
